import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';
import axios from 'axios';

export const fetchUserActivityLogs = createAsyncThunk(
    'userActivityLog/fetch',
    async ({ module, entityId, userName, dateFrom, dateTo, page = 1, limit = 50 } = {}, { dispatch }) => {
        try {
            const params = { page, limit };
            if (module) params.module = module;
            if (entityId) params.entityId = entityId;
            if (userName) params.userName = userName;
            if (dateFrom) params.dateFrom = dateFrom;
            if (dateTo) params.dateTo = dateTo;
            const request = await axios.get('/api/activitylog/fetch', { params, ...getAuthHeader() });
            return request.data;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message ?? 'Aktivitu sa nepodarilo načítať.'));
            throw error;
        }
    }
);

export const fetchActivityLogUsers = createAsyncThunk(
    'userActivityLog/fetchUsers',
    async ({ module } = {}, { dispatch }) => {
        try {
            const params = {};
            if (module) params.module = module;
            const request = await axios.get('/api/activitylog/users', { params, ...getAuthHeader() });
            return request.data;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message ?? 'Zoznam používateľov sa nepodarilo načítať.'));
            throw error;
        }
    }
);
